var Layout = function () {
    this.runLayout();
    return this;
}
export default Layout;